// review
import { BlindReviewCommunityWrap } from "./Wrap";
// components
import AppHeader from "@src/components/common/appHeader/AppHeader";
import { Wrap } from "@src/shared/src";

// 블라인드 후기 영역
const BlindReviewListSection = ({ partnerUuid }: { partnerUuid: string }) => {
  return (
    <Wrap
      fullHeight={false}
      viewportResize={true}
      headerComponent={<AppHeader type="stack" title="블라인드 후기" />}
      contentsComponent={{
        contents: (
          <div className="blind-review-page">
            <section className="blind-review-policy-wrap">
              <h2>웨딩북의 클린 리뷰 정책</h2>
              <p>
                웨딩북은 예비신부 / 신랑님들이 직접 작성한 후기를 수집하여 투명하게 제공하는 것을
                매우 중요하게 생각합니다.
                <br />
                특히 작업성 후기를 필터링하기 위해 시스템 검수, 운영팀 검수를 꼼꼼하게 진행하고
                있습니다.
                <br />
                <br />
                다만 사업자가 사업장 관련 컨텐츠의 삭제를 요청할 경우 정보통신법에 따라 그 즉시 삭제
                또는 임시조치를 취해야 할 의무가 있습니다. 이에 따라 상세 내용은 공개할 수 없으나
                블라인드로 분류된 후기의 유무, 후기수 등을 기준으로 업체 선택에 참고하여 주시기
                바랍니다.
              </p>
            </section>
            <div className="review-list-wrap review-basic-wrap">
              <BlindReviewCommunityWrap partnerUuid={partnerUuid} />
            </div>
          </div>
        ),
      }}
    />
  );
};

export default BlindReviewListSection;
